import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { Container } from "reactstrap";
import { Box, Button, Stack, SvgIcon, Typography, Grid, Snackbar, TextField } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'
import axios from 'axios'
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Controller, useForm } from 'react-hook-form'
// import { useRouter, withRouter } from 'next/router'
// import { useAlert } from 'react-alert'
import { DataGrid } from '@mui/x-data-grid'
import Tooltip from '@mui/material/Tooltip'
// import { createBrowserHistory } from 'history'
// import { useHistory } from "react-router-dom";
// import { Navigate } from "react-router-dom";

import { useNavigate } from 'react-router-dom';

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import { confirmAlert } from 'react-confirm-alert' // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import DeleteIcon from '@mui/icons-material/Delete'
import "../Button.css"
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

// const history = useHistory();
const Practices = () => {
  const rights = useSelector((state) => state.login.rights);
  
  const [isLoading, setLoading] = useState(false)
  document.title = "Practices | LuxBilling";

  // document.title = "Dashboard | Upzet - React Admin & Dashboard Template";
  document.title = "LuxBillingEHR";
  // const auth = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJqdGkiOiIwZmRiNWIxMy0wYzExLTQ4ZTQtOTdmMy1hZjhlOGNmOTJlMjgiLCJ2YWxpZCI6IjEiLCJ1c2VyRW1haWwiOiJhbGlAZ21haWwuY29tIiwicHJhY3RpY2VJZCI6IjEiLCJleHBpcnlEYXRlIjoiNy8zLzIwMjgiLCJicm93c2VyIjoiR29vZ2xlIENocm9tZSIsImFwcGxpY2F0aW9uIjoiTHV4QmlsbGluZyIsIklzQWRtaW4iOiJGYWxzZSIsIlByb3ZpZGVySWQiOiIwIiwiZXhwIjoxODQ2MDgwNTE2LCJpc3MiOiJodHRwOi8vd3d3Lkx1eEJpbGxpbmcuY29tIiwiYXVkIjoiaHR0cDovL3d3dy5MdXhCaWxsaW5nLmNvbSJ9.2Uac6a-c-IPRJFzYSvjxpRych9icwhsebjvB2lgZaOs`
  const navigate = useNavigate();
  const [rows, setRows] = useState(null) 
  const [refresh, setRefresh] = useState(false)

  const token = localStorage.getItem('Token')
  const auth = `Bearer ${token}`
  const headers = {
    Authorization: auth
  }
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.1,
       minWidth: 80,

    },
    
    {
        field: 'practiceName',
        headerName: 'Practice Name',
        headerClassName: 'super-app-theme--header',
        cellClassName: 'gridCell',
        sortable: false,
        flex: 1.5,
         minWidth: 150,
        renderCell: (cellValues) => (
            <Button
            style={{ display: "flex", justifyContent: "flex-start"}}
              size="small"
              variant="text"
              color="info"
              onClick={(event) => {
                openPracticesRegistration(event,cellValues.row.id )
              }}
            >{`${cellValues.row.practiceName}`}</Button>
          ),
      },
      {
        field: 'taxId',
        headerName: 'Tax Id',
        headerClassName: 'super-app-theme--header',
        cellClassName: 'gridCell',
        sortable: false,
        flex: 0.3,
          minWidth: 120,
      },
      {
        field: 'address',
        headerClassName: 'super-app-theme--header',
        headerName: 'Address',
        cellClassName: 'gridCell',
        sortable: false,
        flex: 1,
               minWidth:150,
      },
      {
        field: 'city',
        headerClassName: 'super-app-theme--header',
        headerName: 'City',
        cellClassName: 'gridCell',
        sortable: false,
        flex: 0.5,
               minWidth: 100,
      },
      {
        field: 'state',
        headerClassName: 'super-app-theme--header',
        headerName: 'State',
        cellClassName: 'gridCell',
        sortable: false,
        flex: 0.3,
               minWidth: 100,
      },
         {
        field: 'eFax',
        headerClassName: 'super-app-theme--header',
        headerName: 'Fax #',
        cellClassName: 'gridCell',
        sortable: false,
        flex: 0.3,
          minWidth: 120,

      },
      {
        field: 'phoneNo',
        headerClassName: 'super-app-theme--header',
        headerName: 'PhoneNo',
        sortable: true,
        flex: 0.3,
          minWidth: 120,

      },
      ...(rights?.Delete_Practices
        ? [
      {
        field: 'deleted',
        headerClassName: 'super-app-theme--header',
        headerName: 'Delete',
        sortable: true,
        flex: 0.3,
        minWidth: 80,
        // hide: true,
        // hide: Usertype == 'Admin'?false:true,
        
        renderCell: (cell) => (
        
          <DeleteIcon
            style={{
              marginRight: '5px',
              float: 'right',
              marginTop: '5px',
              color: 'red',
              cursor: 'pointer'
            }}
             onClick={() => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete the record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c7c84",
        heightAuto: false,
        backdrop: true,
        didOpen: () => {
          const popup = document.querySelector(".swal2-popup");
          const container = document.querySelector(".swal2-container");
          const backdrop = document.querySelector(".swal2-backdrop");

          if (popup) popup.style.zIndex = "1801";
          if (container) container.style.zIndex = "1801";
          if (backdrop) backdrop.style.zIndex = "1800";
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const postData = {
            id: cell.row.id,
            deleted: true,
          };

          axios
            .post(`${process.env.REACT_APP_API_URL}/Practices/addPractice`, postData, { headers })
            .then(() => {
              setRefresh(!refresh);

              Swal.fire({
                title: "Deleted!",
                text: "Record deleted successfully.",
                icon: "success",
                showConfirmButton: false,
                timer: 1200,
                heightAuto: false,
              });
            })
            .catch((error) => {
              console.error("There was an error!", error);
              Swal.fire({
                title: "Error!",
                text: "Something went wrong.",
                icon: "error",
                heightAuto: false,
              });
            });
        }
      });
    }}
          ></DeleteIcon>
        )
      }
    ]
    : [])
  ]
  
   const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "white", // Use white or another valid color
    fontSize: "12px",
    color: "black",
    borderColor: "#326C1D",
    whiteSpace: "nowrap",

    "& .MuiDataGrid-root": {
      overflowX: "auto", // Enable horizontal scrolling
    },

    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#377562",
      color: "white",
      fontSize: "14px",
      fontWeight: "bold",
      textAlign: "center",
    },

    "& .MuiDataGrid-cell": {
      fontSize: "12px",
      textAlign: "left",
      overflow: "hidden",
      textOverflow: "ellipsis", // Prevents text overflow
      whiteSpace: "nowrap",
    },

    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637)",
    },
  };
  const gridClasses = {
    columnHeader: 'MuiDataGrid-columnHeaders',
  };
   const openPracticesRegistration = (event, id) => {
    navigate('/PracticeRegistration', { state: { PracticeId: id } })
   
  }
  useEffect(() => {
    setLoading(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}/Practices/getPractices`, {
        headers
      }
      )
      .then((response) => { 
        setRows(response) 
        setLoading(false)
      })
     
      .catch((error) => {
        console.error('There was an error!', error)
      })

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [refresh])
 
  return (
     
      <div className="page-content">
        <Container  >
        <div style={{ width: 200, marginTop: '5px', marginBottom: '0px' }}>
                  <Grid>
                  {rights.Add_Practices && (
                    <Button
                    sx={{ mb: 1 }} className="Button" 
                      onClick={openPracticesRegistration}
                      variant="contained"
                    >
                        <AddOutlinedIcon
                fontSize='small'
                style={{
                  color: 'white',
                  paddingRight: '4px',
                  paddingBottom: '2px'
                }}
              ></AddOutlinedIcon>
                      Add New
                    </Button>
                  )}
                  </Grid>
                  </div>
            
                <Box mb={0} marginTop={0}>
                {isLoading ? (
            <div style={{ margin:'5rem', textAlign:'center' }}>
               <CircularProgress /> 
            </div>
          ) : (
                <div
                      style={{ height: 400, width: "100%", overflowX: "auto" }}
                    >
                {rows === null || rows.length === 0 ? null : (
                  <DataGrid
                    rows={rows}
                    columns={columns}
                   classes={gridClasses}
                   pagination
                   pageSizeOptions={[25]}
                   sx={gridRowStyle}
                   rowHeight={30}
                   initialState={{
                     pagination: {
                       paginationModel: { pageSize: 25, page: 0 },
                     },
                   }}
                  />
                )}
              </div>
          )}
            </Box>
         
        </Container>
      </div>

  );
};

export default Practices;
